import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme) => ({
  switchTripDialogLoader: {},
  closeButton: {
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: theme.palette.grey[500],
  },
  noBg: {
    backgroundColor: "transparent",
  },
  dialogWrapper: {
    zIndex: 999999,
    "& .MuiDialog-paperWidthSm": {
      width: "100%",
      borderRadius: 10,
      margin: 10
    },
  },
  dialogWrapperBottom: {
    "& .MuiDialog-scrollPaper": {
      alignItems: 'flex-end',
    },
  },
  dialogContentWrapper: {
    padding: theme.spacing(5),
  },
  dialogActionWrapper: {
    padding: theme.spacing(0, 5, 5, 5),
  },
  dialogContentIcon: {
    textAlign: "center",
    "& img": {
      maxWidth: 150,
      maxHeight: 150,
    },
  },
  dialogContentTitle: {
    fontWeight: 500,
    fontSize: 23,
    margin: theme.spacing(2, 0),
    textAlign: 'center',
  },
  dialogContentSubTitle: {
    fontSize: 20,
    margin: theme.spacing(2, 0),
  },
  adminInput: {
    margin: theme.spacing(2.5, 0),
    "& .MuiInputLabel-root": {
      transform: "translate(0, 1.5px) scale(1)",
      fontSize: 15,
      fontWeight: 400,
      color: "#000",
    },
    "& .MuiInputBase-root": {
      height: 50,
    },
    "& .MuiInputBase-input": {
      padding: `14px 10px`,
    },
  },
  adminInputLabel: {
    fontSize: 15,
    fontWeight: 400,
    color: "#000",
  },
  smartAppRow: {
    display: 'flex',
    alignItems: 'center',
  },
  smartAppRowIcon: {
    marginRight: theme.spacing(2),
  },
  dialogContentWrapperTop: {
    marginTop: "24px"
  },

  switchTripDialog: {
    zIndex: 999999,
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "859pt",
      borderRadius: 10,
      margin: 10,
      maxHeight: '100%'
    },
  },
  switchTripDialogContentTitle: {
    fontWeight: 500,
    fontSize: "20pt",
    // margin: theme.spacing(2, 0, 0, 0),
    textAlign: 'left',
  },

  switchTripDialogContentSubTitle: {
    // fontWeight: 500,
    fontSize: "12pt",
    // margin: theme.spacing(2, 0),
    textAlign: 'left',
    color: '#888888'
  },

  switchTripCardContainer: {
    padding: theme.spacing(4, 0, 4, 0),
    maxWidth: '100%',
    display: 'grid',
    gap: '20pt',
    gridTemplateColumns: 'auto auto auto'
  },
  switchTripRadio: {
    '&$checked': {
      color: '#ffd428'
    },
    padding: 0,
    gridArea: 'switchTripRadio',
    display: 'inlineBlock',
    color: '#ffd428',
  },
  checked: {},
  switchTripRadioLabel: {
    marginLeft: '14pt',
    fontWeight: 500,
    fontSize: "14pt",
    gridArea: 'switchTripRadioLabel'
  },
  switchTripRadioDescription: {
    gridArea: 'switchTripRadioDescription',
    marginLeft: '14pt',
    fontSize: "12pt",
    color: '#888888',
  },

  switchTripCard: {
    maxWidth: '253pt',
    padding: theme.spacing(2),
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#EAEAEA',
    display: 'grid',
    gridTemplateAreas: `'switchTripRadio switchTripRadioLabel switchTripRadioLabel switchTripRadioLabel switchTripRadioLabel switchTripRadioLabel'
    'switchTripRadio  switchTripRadioDescription switchTripRadioDescription switchTripRadioDescription switchTripRadioDescription switchTripRadioDescription'`,
  },

  switchDialogActionWrapper: {
    padding: theme.spacing(0, 5, 5, 5),
    justifyContent: 'flex-start'
  },

  switchDialogActionButton: {
    height: '40pt',
    width: '90pt',
    borderRadius: '40px',
    fontSize: '18pt'
  },

  switchTripContainer: {
    flexGrow: 1,
  },

  selectReason: {
    width: '253pt',
    color: '#989898',
  },

}));
